import { PFlex, PText } from '@porsche-design-system/components-react'
import React from 'react'

import Collapsible from '../../../shared/components/Collapsible/Collapsible'
import { ApplicationContext } from '../../../shared/utils/Context/ApplicationContext'
import ContentEmpty from '../Empty/ContentEmpty'
import ContentLoading from '../Loading/ContentLoading'

import styles from './contentapplicationslist.module.css'

const ContentApplicationsList = () => {
  const { applications, loadingApps, searchValue } = React.useContext(ApplicationContext)
  const [filteredApplications, setFilteredApplications] = React.useState(applications)

  const searchFilterFunc = (app: any) => {
    if (
      app.department?.match(new RegExp(searchValue, 'i')) ||
      app.icto?.match(new RegExp(searchValue, 'i')) ||
      app.appDescription?.match(new RegExp(searchValue, 'i')) ||
      app.appId?.match(new RegExp(searchValue, 'i'))
    ) {
      return app
    }
    for (let i = 0; i < app.members.length; i++) {
      if (
        app.members[i].email?.match(new RegExp(searchValue, 'i')) ||
        app.members[i].name?.match(new RegExp(searchValue, 'i'))
      ) {
        return app
      }
    }
    if (app.subApp?.length > 0) {
      for (let k = 0; k < app.subApp.length; k++) {
        if (
          app.subApp[k].appId?.match(new RegExp(searchValue, 'i')) ||
          app.subApp[k].subAppDescription?.match(new RegExp(searchValue, 'i'))
        ) {
          return app
        }
        if (app.subApp[k].modules?.length > 0) {
          for (let l = 0; l < app.subApp[k].modules.length; l++) {
            if (
              app.subApp[k].modules[l].appId?.match(new RegExp(searchValue, 'i')) ||
              app.subApp[k].modules[l].moduleDescription?.match(new RegExp(searchValue, 'i'))
            ) {
              return app
            }
          }
        }
      }
    }
  }

  React.useEffect(() => {
    if (searchValue === '') {
      setFilteredApplications(applications)
    } else {
      setFilteredApplications(applications.filter(searchFilterFunc))
    }
  }, [searchValue, applications])

  return (
    <React.Fragment>
      {applications.length >= 1 && Object.keys(applications[0]).length !== 0 && (
        <PFlex justifyContent='center' alignItems='flex-start' className={styles.applicationsList} direction='column'>
          {filteredApplications.map((app: any) => {
            if (app.active) {
              return <Collapsible key={app.app} app={app} />
            }
          })}
          {filteredApplications.length === 0 && (
            <PText>
              Für den angegebenen Suchbegriff <b>"{searchValue}"</b> konnten wir keine Ergebnisse ermitteln.
            </PText>
          )}
        </PFlex>
      )}
      {(applications.length === 0 || Object.keys(applications[0]).length === 0) && (
        <PFlex justifyContent='center' alignItems='center' className={styles.loading} direction='column'>
          {!loadingApps && <ContentEmpty />}
          {loadingApps && <ContentLoading />}
        </PFlex>
      )}
    </React.Fragment>
  )
}

export default ContentApplicationsList
